import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Redux, Slices } from 'spwa-ui-library';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import { useLocation } from '@reach/router';

const { useSelector } = Redux;
const { selectCategoryById } = Slices.categorySlice;

function CategoryBreadcrumbs({ categoryID }) {
  const intl = useIntl();
  const location = useLocation();
  const category = useSelector((state) => selectCategoryById(state, categoryID));

  const generatedPath = generateCategoryRoute({
    category: category,
    locale: intl.locale,
  });

  if (!category) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(
          {
            '@context': 'https://schema.org/',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: `${location.origin}/${intl.locale}/home`,
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: category?.name || '',
                item: `${location.origin}${generatedPath}`,
              },
            ],
          },
          null,
          2
        )}
      </script>
    </Helmet>
  );
}

export default CategoryBreadcrumbs;
